import { combineReducers } from 'redux';
import baseApi from 'services/api/baseApi';
import baseWorkloadApi from 'services/api/baseWorkloadApi';

import user from './user.slice';

export default combineReducers({
  user,
  [baseApi.reducerPath]: baseApi.reducer,
  [baseWorkloadApi.reducerPath]: baseWorkloadApi.reducer,
});
